import { defineComponent as _defineComponent } from 'vue'
import { computed, ref } from 'vue'

  
export default /*#__PURE__*/_defineComponent({
  __name: 'PlaceholderShimmer',
  props: {
    animate: {
      type: Boolean,
      default: false,
    },
    height: {
      type: String,
      default: '100%',
    },
    width: {
      type: String,
      default: '100%',
    },
    slotStatus: {
      type: Boolean,
      default: undefined,
    },
  },
  setup(__props) {

const props = __props;

  
  const isLoadingResource = ref(true)

  const animationStatus = computed(() => {
    if (isLoadingResource.value) return props.animate
    return isLoadingResource.value
  })

  const renderingStatus = computed(() => {
    if (typeof props.slotStatus === 'boolean') return props.slotStatus
    return isLoadingResource.value
  })

  const onResourceLoaded = () => {
    isLoadingResource.value = false
  }

return { __sfc: true,props, isLoadingResource, animationStatus, renderingStatus, onResourceLoaded, computed, ref }
}

})